import firebase from "../firebase";
import CsvParse from 'csv-parse';

import { DbCourseManagementDetails } from "@/database/DbCourseManagement";
import { DbUser, DbUserCourseManagement, DbUserCourseManagementDetail } from "@/database/DbUser";
import { DbUtile, ResultDbCourseManagementDetails } from "@/database/DbUtile";
import { DbHistoryManagementDetail } from "@/database/DbHistoryManagement";

class Common {
    public static createRandomString(n: number) {
        const S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.from(Array(n)).map(()=>S[Math.floor(Math.random()*S.length)]).join('');
    }

    // CSV ダウンロード処理
    public static downloadCsv(csv: string, aTag: any) {
        console.log("downloadCsv", csv);
        const blob = new Blob([ csv ], { "type" : "text/csv" });
        aTag.href = window.URL.createObjectURL(blob);
        aTag.click();
    }

    // 入力チェック
    public static isValidate(value: any | null, validateStatus: any, message: string): boolean {
        if (typeof value == 'string'){
            if((value == null) || (value == "")){
                validateStatus.error = true;
                validateStatus.message = message;
                return false;
            }
        }
        else if (typeof value == 'number'){
            if(value == 0){
                validateStatus.error = true;
                validateStatus.message = message;
                return false;
            }
        }
        return true;
    }

    // ユーザーが登録済みかチェックする
    public static sendMail(from: string, to: string, subject: string, body: string): Promise<any> {
        const data: any = {from: from, to: to, subject: subject, text: body};
        // .envに管理者メールアドレスがある場合はdataに追加
        const envMailAddresses = process.env.VUE_APP_ADMIN_MAIL_ADDRESSES;
        if (envMailAddresses !== undefined) {
            const addresses = envMailAddresses.split(',');
            data.bcc = addresses;
        }

        // firebase functions で sendMail を実行
        return new Promise((resolve,reject) => {
            const func = firebase.functions().httpsCallable('sendMail');
            func(data)
                .then((result) => {
                    resolve( result );
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    public static ckDate(strDate: string): boolean {
        const separator = "/";
        if(!strDate.match(/^\d{4}\/\d{2}\/\d{2}$/)){
            console.log('ckDate false 1');
            return false;
        }
        const y = Number(strDate.split( separator )[0]);
        const m = Number(strDate.split( separator )[1]) - 1;
        const d = Number(strDate.split( separator )[2]);
        const date = new Date(y,m,d);
        console.log('y,m,d',[y,m,d]);
        if(date.getFullYear() != y || date.getMonth() != m || date.getDate() != d){
            console.log('ckDate false 2');
            return false;
        }
        return true;
    }

    public static isInteger(n: number): boolean {
        return n === +n && n === (n|0);
    }

    // ロゴURLを取得
    public static getLogoUrl(): string {
        return require("../assets/res/Yokohama_KGA_Logo.svg");
    }

    public static getLoginPath(currentPath: string, adminParam: string): string {
        const isAdmin = currentPath.indexOf('/admin') === 0 || adminParam === 'true';
        return `/${isAdmin ? 'admin' : 'students'}/login`;
    }

    /** ライブ章判定子 */
    public static isLive(detail: DbCourseManagementDetails) {
        return (detail.classification == "オンデマンド")? false : true;
    }

    /** ユーザー受講詳細を履歴と整合した状態で取得します。不整合がある場合はデータ更新も合わせて行います。 */
    public static async getUserCourseManagementDetail(
        userHistoryDetail: DbHistoryManagementDetail | undefined,
        user: DbUser,
        userId: string,
        courseId: string,
        courseDetail: ResultDbCourseManagementDetails
    ): Promise<DbUserCourseManagementDetail> {
        // ステータス
        let status = DbUserCourseManagementDetail.STATUS.NotAttended;

        // ユーザー受講詳細の取得
        const dbUtile: DbUtile = new DbUtile();
        let userCourseDetail: DbUserCourseManagementDetail | undefined = await dbUtile.getUserCourseManagementDetail(userId, courseId, courseDetail.id!);

        // ユーザー受講詳細のステータスと比較
        if (userCourseDetail !== undefined && this.checkUpdateStatus(status, userCourseDetail.status)) status = userCourseDetail.status;
        // ユーザー履歴詳細のステータスと比較
        if (userHistoryDetail !== undefined && this.checkUpdateStatus(status, userHistoryDetail.status)) status = userHistoryDetail.status;
        // 動画の場合はローカルストレージのステータスと比較
        if (!this.isLive(courseDetail.courseManagementDetails!)) {
            const key      = `video-current-time-${courseId}-${courseDetail.id!}-${userId ?? 'admin'}`;
            const progress = localStorage.getItem(key);
            if (progress !== null) {
                const json        = JSON.parse(progress);
                const localStatus = json.maxSec === json.duration ? DbUserCourseManagementDetail.STATUS.Done : DbUserCourseManagementDetail.STATUS.During;
                if (this.checkUpdateStatus(status, localStatus)) status = localStatus;
            }
        }

        // ユーザー受講詳細の更新
        if (userCourseDetail === undefined || this.checkUpdateStatus(userCourseDetail.status, status)) {
            console.warn('Update user course management detail:', userCourseDetail?.status, status);
            userCourseDetail = await dbUtile.updateUserCourseManagementDetail(userId, courseId, courseDetail.id!, status);
        }
        // ユーザー履歴詳細の更新
        if (userHistoryDetail === undefined || this.checkUpdateStatus(userHistoryDetail.status, status)) {
            console.warn('Update user history management detail:', userHistoryDetail?.status, status);
            const ucm = new DbUserCourseManagement();
            ucm.id     = courseId;
            ucm.status = status;
            dbUtile.addDbHistoryManagementDetails(userId, user, courseId, ucm, courseDetail.id!, courseDetail.courseManagementDetails!);
        }

        return userCourseDetail;
    }

    /** 自身のステータス更新の必要性をチェックします。更新する必要がある場合はtrueを返却します。 */
    public static checkUpdateStatus = (own: string, dist: string): boolean => {
        switch (own) {
            case DbUserCourseManagementDetail.STATUS.NotAttended:
                return dist === DbUserCourseManagementDetail.STATUS.During || dist === DbUserCourseManagementDetail.STATUS.Done;
            case DbUserCourseManagementDetail.STATUS.During:
                return dist === DbUserCourseManagementDetail.STATUS.Done;
            default:
                return false;
        }
    };

    /** TSVをパースします */
    public static parseTsv(data: string): Promise<string[][]> {
        return new Promise((resolve,reject) => {
            const options: CsvParse.Options = {
                delimiter: '\t',
                quote: '"',
                escape: '"',
                relax: true,
            };
            CsvParse(data, options, (error, records) => {
                if (error !== undefined) {
                    console.error("parseTsv error", error);
                    reject(error);
                } else {
                    console.log("records", records);
                    resolve(records);
                }
            });
        });
    }
}

export default Common;
